import cn from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';
import CallNumber from '@bibliocommons/call-number';
import Edition from '@bibliocommons/shared-edition';
import PrimaryLanguage from '@bibliocommons/shared-primary-language';
import PublicationDate from '@bibliocommons/shared-publication-date';

import './FormatInfo.scss';

export default function FormatInfo({ item, className, showEdition, showLanguage, showCallNumber }) {
  const format = item.getIn(['briefInfo', 'format']);
  const publicationDate = item.getIn(['briefInfo', 'publicationDate']);
  return (
    <div className={cn('cp-format-info', className)}>
      <div className="format-info-main-content">
        <span className="cp-format-indicator" data-test-id="format-indicator">
          <FormattedMessage id={`FORMAT.${format.toLowerCase()}`} />
        </span>
        {publicationDate && <PublicationDate publicationDate={publicationDate} />}
        {showEdition && <Edition edition={item.getIn(['briefInfo', 'edition'])} />}
        {showLanguage && <PrimaryLanguage bib={item} />}
      </div>
      {showCallNumber && <CallNumber callNumber={item.getIn(['briefInfo', 'callNumber'])} />}
    </div>
  );
}

FormatInfo.displayName = 'FormatInfo';

FormatInfo.propTypes = {
  item: ImmutablePropTypes.map.isRequired,
  className: PropTypes.string,
  showEdition: PropTypes.bool,
  showLanguage: PropTypes.bool,
  showCallNumber: PropTypes.bool
};

FormatInfo.defaultProps = {
  showLanguage: true
};
